// extracted by mini-css-extract-plugin
module.exports = {"addToHomeScreen":"AddToHomeScreen_addToHomeScreen__KY9s2"};